import { type Locale, SUPPORTED_LOCALES } from '@giyus/i18n';
import { Button } from '@giyus/ui';
import { useTranslation } from 'react-i18next';

/** Troca de idioma sem recarregar (REQ-FE-005). */
export function LanguageSwitcher() {
  const { t, i18n } = useTranslation('common');
  const current = i18n.resolvedLanguage ?? i18n.language;

  const change = (locale: Locale): void => {
    void i18n.changeLanguage(locale);
  };

  return (
    <div role="group" aria-label={t('language.label')} className="flex items-center gap-1">
      {SUPPORTED_LOCALES.map((locale) => (
        <Button
          key={locale}
          size="sm"
          variant={current === locale ? 'secondary' : 'ghost'}
          aria-pressed={current === locale}
          lang={locale}
          onClick={() => {
            change(locale);
          }}
        >
          {t(`language.${locale}`)}
        </Button>
      ))}
    </div>
  );
}
